import React, {Component} from 'react';
import PropTypes from "prop-types";

class InfoBanner extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired
    };

    static defaultProps = {
        messageKey: null,
        messageText: null
    };

    constructor(props) {

        super(props);

        this.state = {
            messageKey: props.messageKey,
            messageText: props.messageText,
            approvedBanner: []
        };

        this.translate = this.props.baseData.translate;
        this.saveSettings = this.props.baseData.saveSettings;

        this.approvedInfo = this.approvedInfo.bind(this);

    }

    componentWillMount() {

        const settings = this.props.baseData.userData.settings ? this.props.baseData.userData.settings : {};
        const newState = {};

        // Gesehene Banner aus den userprops laden.
        const infos = (settings.approvedBanner) ? settings.approvedBanner : null;

        if (infos) {
            const parseInfos = JSON.parse(infos);

            if (parseInfos.length > 0) newState.approvedBanner = parseInfos;
        }

        if (newState) this.setState(newState);

    }

    approvedInfo() {

        const approvedBanner = [].concat(this.state.approvedBanner).concat(this.state.messageKey);

        this.setState({
            approvedBanner
        });

        if (this.saveSettings && approvedBanner) {
            this.saveSettings('approvedBanner', JSON.stringify(approvedBanner));
        }

    }

    getInfoMessage() {

        return (this.state.approvedBanner.indexOf(this.state.messageKey) === -1) ? this.props.messageText : null;

    }

    render() {

        if (!this.state.messageKey || !this.state.messageText) return null;

        const message = this.getInfoMessage();

        if (!message) return null;

        return (
            <div className="infoBanner">
                <div>
                    <p>{message}</p>
                </div>

                <span className="approved" onClick={() => this.approvedInfo()}>x</span>
            </div>
        );

    }

}

export default InfoBanner;